export default __webpack_public_path__ + "static/media/7_1_0.71e31b6b.png";